import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL ?? ""}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORY_LABELS = {
  F_170_185: { it: "Donna 170–185 cm" },
  F_150_169: { it: "Donna 150–169 cm" },
  M_180_195: { it: "Uomo 180–195 cm" },
  M_170_179: { it: "Uomo 170–179 cm" },
  OUT: { it: "Fuori parametri" },
};

export const STATUS_LABELS = { new: "Da valutare", approved: "Approvata", rejected: "Non approvata" };


export const measureRows = (a) => [
  ["Busto · Vita · Fianchi", a.bust ? `${a.bust} · ${a.waist} · ${a.hips} cm` : ""],
  ["Scarpe", a.shoes], ["Capelli", a.hair], ["Occhi", a.eyes],
];
